window.initJobLogsDatatable = () => {
  if (!$('#job-logs-datatable').length) return;

  window.jobLogsTable = $('#job-logs-datatable').DataTable({
    processing: true,
    searching: false,
    retrieve: true,
    serverSide: true,
    order: [[14, 'desc']],
    ajax: {
      url: $('#job-logs-datatable').data('source'),
      data: function (d) {
        d.search = { value: $('#search-job-logs-datatable').val(), regex: false }
      }
    },
    language: {
      'oPaginate': {
        'sFirst': '',
        'sLast': ''
      }
    },
    info: false,
    pagingType: 'full_numbers',
    createdRow: (row, data, index) => {
      $(row).addClass('hover-secondary small');
      $(row).attr("data-action", "click->modal#set");
      $(row).attr("data-src", `/developers/job_logs/${data.id}/details_modal`);
    },

    columns: jobLogColumns()
  });

  //setup before functions
  var typingTimer;                //timer identifier
  var doneTypingInterval = 1000;  //time in ms, 1 second for example
  var $input = $('#search-job-logs-datatable');

  //on keyup, start the countdown
  $input.on('keyup', function () {
    $(this).val() ? $('#search-job-logs-clear').removeClass('d-none') : $('#search-job-logs-clear').addClass('d-none')
    clearTimeout(typingTimer);
    typingTimer = setTimeout(window.jobLogsTable.ajax.reload, doneTypingInterval);
  });

  //on keydown, clear the countdown
  $input.on('keydown', function () {
    clearTimeout(typingTimer);
  });

  if ($input.length && $input.val().length == 0) {
    $('#search-job-logs-clear').addClass('d-none');
  }

  $('#search-job-logs-clear').on('click', function () {
    $input.val('')
    $input.trigger('keyup');
    $('#search-job-logs-clear').addClass('d-none');
  })
}

const formatTime = (timestamp) => {
  let month = timestamp.getMonth() + 1;
  let date = timestamp.getDate();
  let hours = timestamp.getHours();
  let minutes = timestamp.getMinutes();
  let seconds = timestamp.getSeconds();
  if (month < 10) month = `0${month}`;
  if (date < 10) date = `0${date}`;
  if (hours < 10) hours = `0${hours}`;
  if (minutes < 10) minutes = `0${minutes}`;
  if (seconds < 10) seconds = `0${seconds}`;

  return `${month}/${date} - ${hours}:${minutes}:${seconds}`;
}

function jobLogColumns() {
  return [
      { data: 'name' },
      { data: 'integer_0' },
      { data: 'integer_1' },
      { data: 'integer_2' },
      { data: 'string_0' },
      { data: 'string_1' },
      { data: 'string_2' },
      { data: 'date_0' },
      { data: 'date_1' },
      { data: 'date_2' },
      { data: 'boolean_0' },
      { data: 'boolean_1' },
      { data: 'boolean_2' },
      {
        data: 'success',
        render: (data, display, row) => {
          return data === 'true' ? 'Yes' : 'No';
        }
      },
      {
        data: 'enqueued_at', render: (data, display, row) => {
          const time = new Date(data);
          return time.toLocaleDateString() === 'Invalid Date' ? '---' : `${formatTime(time)}`;        }
      },
      {
        data: 'started_at', render: (data,display,row) => {
          const time = new Date(data);
          return time.toLocaleDateString() === 'Invalid Date' ? '---' : `${formatTime(time)}`;
        }
      },
      {
        data: 'finished_at', render: (data, display, row) => {
          const time = new Date(data);
          return time.toLocaleDateString() === 'Invalid Date' ? '---' : `${formatTime(time)}`;        }
      },
      { data: 'attempt_number' }
  ];
}

$(document).on('turbolinks:load', () => {
  window.initJobLogsDatatable();
});
